import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
// import Switch from "@mui/material/Switch";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import AuthService from "services/auth-service";

function InfoCard() {
  const [settings, setSettings] = useState(null);

  useEffect(() => { fetchSettings() }, []);

  const fetchSettings = async () => {
    const response = await AuthService.settings();
    setSettings(response);
  };

  return (
    <Card sx={{ height: "100%", boxShadow: "none" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Information
        </MDTypography>
        <MDTypography variant="body2" color="secondary">
          <Tooltip placement="top" sx={{ display: "none" }}>
            <Icon>edit</Icon>
          </Tooltip>
        </MDTypography>
      </MDBox>
      <MDBox p={2}>
        <MDBox opacity={0.3}>
          <Divider />
        </MDBox>
        <MDBox>
          <MDBox display="flex" py={1} pr={2}>
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Name: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              {settings?.name ?? " "}
            </MDTypography>
          </MDBox>
          <MDBox display="flex" py={1} pr={2}>
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Email: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              {settings?.email ?? " "}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
      {/* <MDBox pt={1} pb={2} px={2} lineHeight={1.25} sx={{ display: "none" }}>
        <MDTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase">
          account
        </MDTypography>
        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
          <MDBox mt={0.5}>
            <Switch checked={true} />
          </MDBox>
          <MDBox width="80%" ml={0.5}>
            <MDTypography variant="button" fontWeight="regular" color="text">
              Email me when someone follows me
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
          <MDBox mt={0.5}>
            <Switch checked={false} />
          </MDBox>
          <MDBox width="80%" ml={0.5}>
            <MDTypography variant="button" fontWeight="regular" color="text">
              Email me when someone answers on my post
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
          <MDBox mt={0.5}>
            <Switch checked={true} />
          </MDBox>
          <MDBox width="80%" ml={0.5}>
            <MDTypography variant="button" fontWeight="regular" color="text">
              Email me when someone mentions me
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox> */}
    </Card>
  );
}

InfoCard.defaultProps = {
};

InfoCard.propTypes = {
};

export default InfoCard;
